module.exports = __webpack_public_path__ + "asset_7.png";